<template>
  <div>
    <spinner  v-if="false"></spinner>
    <div v-else class="col-sm-12">

        <div class="col-sm-12 col-md-12">
            
                <h2 class="font-w300 push-10 align-center"><i class="fa fa-cloud-download fa-1x push-15-r "></i>Cloud Live Monitor</h2>
                <h4 class="font-w300 push-10 align-center">{{GraphTitle}}</h4>

                <div class="row">
                <div v-if="overlayParameters.liveType=='Device'" class="col-xs-12 push">
                    <select  v-model="selectedDeviceDataType">
                        <option value="current_RMS">{{ labelSelectorCurrentRMS[actualLanguage] }}</option>
                        <option value="power">{{ labelSelectorPower[actualLanguage] }}</option>
                        <option value="input_VRMS">{{ labelSelectorInputVRMS[actualLanguage] }}</option>
                    </select>
                </div>
                </div>

                

                <!-- Fonctionne pas bien en modal petit taille:   <div style="max-height:200px">           -->
                <div v-if="flagDisplayNewGraph" class="col-sm-12 col-lg-12">
                  <div id="chart">
                    <apexchart type="area" height="400" :options="chartOptions" :series="chartDataSeries"></apexchart>
                  </div>
                </div>
                <div v-else>
                    <div class="col-sm-12">
                        <div class="block-content block-content-full bg-gray-lighter text-center" >
                            <line-chart :chartData="graphData"></line-chart>
                        </div>
                    </div>
                </div>
                


                <div class="form-group">
                    <div class="col-sm-12 col-md-12">
                        <div>
                            <p><button @click="testGetLiveCloud()" type="button" class="btn btn-block btn-success" name="button">
                            <spinner size="small" v-if="dataIsLoading"></spinner>
                            <span v-else><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownload[actualLanguage]}}</span></button></p>
                        </div> 
                    </div>
                </div>

          </div>
    </div>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '@/components/Spinner.vue'
import LineChart from '@/components/LineChart'
import _ from 'underscore'

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
//Next line are executed in PortGraph!!!
//Vue.use(VueApexCharts)
//Vue.component('apexchart', VueApexCharts)

export default {
  name: 'ChannelCloudLiveModalDisplay',
  components: {
    Spinner,
    LineChart
  },
  data() {
    return {
      channelIndex : 0,
      dataTimestamp : [],
      dataTimestampEpoch : [],
      dataRead : [],
      GraphTitle : '',
      selectedDeviceDataType:'current_RMS',

      I_RMS_Port01 : [],
      I_RMS_Port02 : [],
      I_RMS_Port03 : [],
      I_RMS_Port04 : [],
      I_RMS_Port05 : [],
      I_RMS_Port06 : [],

      PowerPort01 : [],
      PowerPort02 : [],
      PowerPort03 : [],
      PowerPort04 : [],
      PowerPort05 : [],
      PowerPort06 : [],
      ActualChannelPortList : [],
      PowerActualChannel : [],

      InputV_RMS01 : [],
      InputV_RMS02 : [],
      InputV_RMS03 : [],
      InputV_RMS04 : [],
      InputV_RMS05 : [],
      InputV_RMS06 : [],

      dataIsLoading : false,
      pooling : null,
      dataPoolingIsActive : false,
      dataPoolingCounter : 0, 

      actualLanguage : "FR",
      labelSectionUser: {FR: 'Accès usager', EN: 'User access'},
      labelSectionGroup: {FR: 'Group usagers', EN: 'User group'},

      labelSelectorCurrentRMS: {FR: 'Courant (A)', EN: 'Current (A)'},
      labelSelectorPower: {FR: 'Puissance (W)', EN: 'Power (W)'},
      labelSelectorInputVRMS: {FR: 'Tension du senseur (mV)', EN: 'Sensor voltage (mV)'},
      

      labelAppareilDevice: {FR: 'Appareil actuel (W)', EN: 'Actual Device (W)'},
      labelButtonDownload: {FR: "Téléchargement", EN: 'Download'},

      graphData: {
        labels: _.map(this.portData, function(data){ return data.timestamp; }),
        //labels: _.map(this.portData, function(data){ return data.timestamp; }),
        datasets: [{
          label: 'Mesure',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: _.map(this.portData, function(data){ return data.avrPower; })
        }]
      },

      flagDisplayNewGraph : true,
      chartDataSeries: [],
        
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 400,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          },
        },
        xaxis: {
            //type: 'datetime'
          }
      },




    }


  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('overlayStore', ['overlayParameters']),
  },


  methods: {

    testGetLiveCloud() {

        //var actualEpochMilisec = moment().unix()*1000
        //var startTimestamp = moment(actualEpochMilisec-20000).format('YYYY-MM-DDTHH:mm:ss')

        //If data are empty, we request data with timestamp delayed by 20 sec
        var startTimestamp_epoch = moment().unix() - 20
        this.dataIsLoading = true

        if(this.dataTimestampEpoch.length > 0){
            startTimestamp_epoch = this.dataTimestampEpoch[this.dataTimestampEpoch.length-1]
        }

        var requestData = { 'postAction':'GetDeviceLiveCloudReadings',
                            'bundleId': this.actualBundle.bundleId,
                            'deviceId':this.overlayParameters.deviceId,
                            'startTimestamp':startTimestamp_epoch,
                            'channelId': this.overlayParameters.channelId,
                            }
        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){

                //console.log(response.data)

                for(let n=0;n < response.data.DataTimestamp.length;n++){
                        this.dataTimestampEpoch.push(response.data.DataTimestamp[n])
                        this.dataTimestamp.push(moment(response.data.DataTimestamp[n]*1000).format('HH:mm:ss'))

                        this.I_RMS_Port01.push(response.data.LiveData[n].currentRMS[0])
                        this.I_RMS_Port02.push(response.data.LiveData[n].currentRMS[1])
                        this.I_RMS_Port03.push(response.data.LiveData[n].currentRMS[2])
                        this.I_RMS_Port04.push(response.data.LiveData[n].currentRMS[3])
                        this.I_RMS_Port05.push(response.data.LiveData[n].currentRMS[4])
                        this.I_RMS_Port06.push(response.data.LiveData[n].currentRMS[5])

                        this.PowerPort01.push(response.data.LiveData[n].power[0])
                        this.PowerPort02.push(response.data.LiveData[n].power[1])
                        this.PowerPort03.push(response.data.LiveData[n].power[2])
                        this.PowerPort04.push(response.data.LiveData[n].power[3])
                        this.PowerPort05.push(response.data.LiveData[n].power[4])
                        this.PowerPort06.push(response.data.LiveData[n].power[5])

                        this.InputV_RMS01.push(response.data.LiveData[n].inputV_RMS[0])
                        this.InputV_RMS02.push(response.data.LiveData[n].inputV_RMS[1])
                        this.InputV_RMS03.push(response.data.LiveData[n].inputV_RMS[2])
                        this.InputV_RMS04.push(response.data.LiveData[n].inputV_RMS[3])
                        this.InputV_RMS05.push(response.data.LiveData[n].inputV_RMS[4])
                        this.InputV_RMS06.push(response.data.LiveData[n].inputV_RMS[5])

                        if(this.overlayParameters.liveType=='Channel'){
                            var ActualChannelPower = 0
                            //console.log("ActualChannelPortList")
                            //console.log(this.ActualChannelPortList)
                            if(this.ActualChannelPortList.indexOf("1")>-1){ActualChannelPower+=response.data.LiveData[n].power[0]}
                            if(this.ActualChannelPortList.indexOf("2")>-1){ActualChannelPower+=response.data.LiveData[n].power[1]}
                            if(this.ActualChannelPortList.indexOf("3")>-1){ActualChannelPower+=response.data.LiveData[n].power[2]}
                            if(this.ActualChannelPortList.indexOf("4")>-1){ActualChannelPower+=response.data.LiveData[n].power[3]}
                            if(this.ActualChannelPortList.indexOf("5")>-1){ActualChannelPower+=response.data.LiveData[n].power[4]}
                            if(this.ActualChannelPortList.indexOf("6")>-1){ActualChannelPower+=response.data.LiveData[n].power[5]}
                            this.PowerActualChannel.push(ActualChannelPower)

                        }

                    }


                    if(this.overlayParameters.liveType=='Channel'){
                        this.updateGraphDataChannel()
                    }   

                    if(this.overlayParameters.liveType=='Device'){
                        this.updateGraphDataDevice()
                    }               


                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                this.dataIsLoading = false
            })
        
        //------------------------------------------------
        //This code ensure that pooling will not continu after 100 request
        this.dataPoolingCounter += 1
        if(this.dataPoolingCounter==100){
            clearInterval(this.polling)
            this.dataPoolingIsActive=false
        }
    },


	pollData () {
		this.polling = setInterval(() => {
			this.testGetLiveCloud()
		}, 5000)
    },
    

    updateGraphDataChannel(){
        var graphDataset = []
        this.chartDataSeries = []
        var NewGraphDataTempo = []
        var actualValue = 0.0


        if(this.ActualChannelPortList.indexOf("1")>-1){
            graphDataset.push({ label: 'Module Port 1 (W)',
                                backgroundColor: 'rgba(70, 195, 123, 0.2)',
                                borderColor: 'rgba(5, 210, 92, .25)',
                                pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                                data: this.PowerPort01})

            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerPort01.length;i++){
                actualValue = this.PowerPort01[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:'Module Port 1 (W)',data:NewGraphDataTempo})
        }

        if(this.ActualChannelPortList.indexOf("2")>-1){
            graphDataset.push({ label: 'Module Port 2 (W)',
                                backgroundColor: 'rgba(70, 195, 123, 0.2)',
                                borderColor: 'rgba(5, 210, 92, .25)',
                                pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                                data: this.PowerPort02})

            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerPort02.length;i++){
                actualValue = this.PowerPort02[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:'Module Port 2 (W)',data:NewGraphDataTempo})
        }

        if(this.ActualChannelPortList.indexOf("3")>-1){
            graphDataset.push({ label: 'Module Port 3 (W)',
                                backgroundColor: 'rgba(70, 195, 123, 0.2)',
                                borderColor: 'rgba(5, 210, 92, .25)',
                                pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                                data: this.PowerPort03})

            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerPort03.length;i++){
                actualValue = this.PowerPort03[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:'Module Port 3 (W)',data:NewGraphDataTempo})


        }

        if(this.ActualChannelPortList.indexOf("4")>-1){
            graphDataset.push({ label: 'Module Port 4 (W)',
                                backgroundColor: 'rgba(70, 195, 123, 0.2)',
                                borderColor: 'rgba(5, 210, 92, .25)',
                                pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                                data: this.PowerPort04})

            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerPort04.length;i++){
                actualValue = this.PowerPort04[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:'Module Port 4 (W)',data:NewGraphDataTempo})

        }


        if(this.ActualChannelPortList.indexOf("5")>-1){
            graphDataset.push({ label: 'Module Port 5 (W)',
                                backgroundColor: 'rgba(70, 195, 123, 0.2)',
                                borderColor: 'rgba(5, 210, 92, .25)',
                                pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                                data: this.PowerPort05})

            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerPort05.length;i++){
                actualValue = this.PowerPort05[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:'Module Port 5 (W)',data:NewGraphDataTempo})
        }

        if(this.ActualChannelPortList.indexOf("6")>-1){
            graphDataset.push({ label: 'Module Port 6 (W)',
                                backgroundColor: 'rgba(70, 195, 123, 0.2)',
                                borderColor: 'rgba(5, 210, 92, .25)',
                                pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                                data: this.PowerPort06})
            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerPort06.length;i++){
                actualValue = this.PowerPort06[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:'Module Port 6 (W)',data:NewGraphDataTempo})


        }

        graphDataset.push({ label: this.labelAppareilDevice[this.actualLanguage],
                            backgroundColor: 'rgba(70, 195, 123, 0.2)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: this.PowerActualChannel})

            NewGraphDataTempo = []
            for(var i = 0; i < this.PowerActualChannel.length;i++){
                actualValue = this.PowerActualChannel[i]
                NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
              }
            this.chartDataSeries.push({name:this.labelAppareilDevice[this.actualLanguage],data:NewGraphDataTempo})



        //JSON.parse(JSON.stringify(graphDataset))
      this.graphData= {
        labels: this.dataTimestamp,
        //labels: _.map(this.portData, function(data){ return data.timestamp; }),
        datasets: graphDataset
      }
    },


    updateGraphDataDevice(){
        var graphDataset = []
        var portDataTempo = []

        this.chartDataSeries = []
        var NewGraphDataTempo = []
        var actualValue = 0.0

        if(this.selectedDeviceDataType=='current_RMS'){portDataTempo=this.I_RMS_Port01}
        if(this.selectedDeviceDataType=='power'){portDataTempo=this.PowerPort01}
        if(this.selectedDeviceDataType=='input_VRMS'){portDataTempo=this.InputV_RMS01}
        graphDataset.push({ label: 'Port 1',
                            backgroundColor: 'rgba(70, 195, 123, 0.1)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: portDataTempo})
        NewGraphDataTempo = []
        for(var i = 0; i < portDataTempo.length;i++){
            actualValue = portDataTempo[i]
            NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
          }
        this.chartDataSeries.push({name:'Port 1',data:NewGraphDataTempo})



        if(this.selectedDeviceDataType=='current_RMS'){portDataTempo=this.I_RMS_Port02}
        if(this.selectedDeviceDataType=='power'){portDataTempo=this.PowerPort02}
        if(this.selectedDeviceDataType=='input_VRMS'){portDataTempo=this.InputV_RMS02}
        graphDataset.push({ label: 'Port 2',
                            backgroundColor: 'rgba(70, 195, 123, 0.1)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: portDataTempo})
        NewGraphDataTempo = []
        for(var i = 0; i < portDataTempo.length;i++){
            actualValue = portDataTempo[i]
            NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
          }
        this.chartDataSeries.push({name:'Port 2',data:NewGraphDataTempo})


        if(this.selectedDeviceDataType=='current_RMS'){portDataTempo=this.I_RMS_Port03}
        if(this.selectedDeviceDataType=='power'){portDataTempo=this.PowerPort03}
        if(this.selectedDeviceDataType=='input_VRMS'){portDataTempo=this.InputV_RMS03}
        graphDataset.push({ label: 'Port 3',
                            backgroundColor: 'rgba(70, 195, 123, 0.1)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: portDataTempo})
        NewGraphDataTempo = []
        for(var i = 0; i < portDataTempo.length;i++){
            actualValue = portDataTempo[i]
            NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
          }
        this.chartDataSeries.push({name:'Port 3',data:NewGraphDataTempo})


        if(this.selectedDeviceDataType=='current_RMS'){portDataTempo=this.I_RMS_Port04}
        if(this.selectedDeviceDataType=='power'){portDataTempo=this.PowerPort04}
        if(this.selectedDeviceDataType=='input_VRMS'){portDataTempo=this.InputV_RMS04}
        graphDataset.push({ label: 'Port 4',
                            backgroundColor: 'rgba(70, 195, 123, 0.1)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: portDataTempo})
        NewGraphDataTempo = []
        for(var i = 0; i < portDataTempo.length;i++){
            actualValue = portDataTempo[i]
            NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
          }
        this.chartDataSeries.push({name:'Port 4',data:NewGraphDataTempo})


        if(this.selectedDeviceDataType=='current_RMS'){portDataTempo=this.I_RMS_Port05}
        if(this.selectedDeviceDataType=='power'){portDataTempo=this.PowerPort05}
        if(this.selectedDeviceDataType=='input_VRMS'){portDataTempo=this.InputV_RMS05}
        graphDataset.push({ label: 'Port 5',
                            backgroundColor: 'rgba(70, 195, 123, 0.1)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: portDataTempo})
        NewGraphDataTempo = []
        for(var i = 0; i < portDataTempo.length;i++){
            actualValue = portDataTempo[i]
            NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
          }
        this.chartDataSeries.push({name:'Port 5',data:NewGraphDataTempo})


        if(this.selectedDeviceDataType=='current_RMS'){portDataTempo=this.I_RMS_Port06}
        if(this.selectedDeviceDataType=='power'){portDataTempo=this.PowerPort06}
        if(this.selectedDeviceDataType=='input_VRMS'){portDataTempo=this.InputV_RMS06}
        graphDataset.push({ label: 'Port 6',
                            backgroundColor: 'rgba(70, 195, 123, 0.1)',
                            borderColor: 'rgba(5, 210, 92, .25)',
                            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                            pointBorderColor: '#fff',
                            pointHoverBackgroundColor: '#fff',
                            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                            data: portDataTempo})
        NewGraphDataTempo = []
        for(var i = 0; i < portDataTempo.length;i++){
            actualValue = portDataTempo[i]
            NewGraphDataTempo.push([this.dataTimestampEpoch[i]-this.dataTimestampEpoch[0],actualValue.toFixed(3)])
          }
        this.chartDataSeries.push({name:'Port 6',data:NewGraphDataTempo})


      this.graphData= {
        labels: this.dataTimestamp,
        //labels: _.map(this.portData, function(data){ return data.timestamp; }),
        datasets: graphDataset
      }

    },



  },

    created () {
        this.pollData()
        this.dataPoolingIsActive = true
    },

    beforeDestroy () {
        if(this.dataPoolingIsActive){
            //console.log('----Pooling Clear Interval----')
            clearInterval(this.polling)
        }
    },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.channelIndex = this.overlayParameters.channelIndex

    clearInterval()
    //Voir ceci : https://renatello.com/vue-js-polling-using-setinterval/
    //setInterval(function(){ alert("---Allo je recalll---"); }, 30000);
    //setInterval(this.testGetLiveCloud(), 3000);

    if(this.overlayParameters.liveType=='Channel'){
        this.GraphTitle = this.actualBundle.channels[this.overlayParameters.channelIndex].ChannelData.channelInfo.channelName
        this.ActualChannelPortList = this.actualBundle.channels[this.overlayParameters.channelIndex].ChannelData.linkedDevicePorts.ports 
    }

     if(this.overlayParameters.liveType=='Device'){
        this.GraphTitle = this.actualBundle.devices[this.overlayParameters.deviceIndex].DeviceData.deviceInfo.name
    }   


  }


}
</script>



// WEBPACK FOOTER //
// ChannelCloudLiveModalDisplay.vue?9cb90380